/**
 * divisions.js — the Division picklist, one list for every form.
 *
 * Restricted to two values. The spelling is PLURAL to match what is already
 * stored: 539 rows say "Services" and 72 say "Solutions", so switching to a
 * singular "Service" would orphan all of them.
 *
 * Anything else already in the data (29 "Staffing", a handful of uppercase
 * strays, one "SERVICES & SOLUTIONS") is legacy. `divisionOptions` keeps a
 * row's own value in its dropdown so opening an old record does not silently
 * blank it — a picklist with no fallback is how a field gets quietly wiped on
 * the next save. Nothing OFFERS those values; they only survive where they are.
 */
export const DIVISIONS = ['Services', 'Solutions'];

/** The two choices, plus this row's current value when it is something else. */
export const divisionOptions = (current) => {
  const v = (current || '').trim();
  return !v || DIVISIONS.includes(v) ? DIVISIONS : [...DIVISIONS, v];
};
